import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { SessionService } from "src/app/features/http-services/session.service";

@Component({
  selector: 'xchange-invalid-login',
  templateUrl: './invalid-login.component.html',
  styleUrl: './invalid-login.component.scss'
})
export class InvalidLoginComponent {
  constructor(
    private bsModalRef: BsModalRef,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
 
  }

  onConfirm() {
    this.bsModalRef.hide();
    this.sessionService.logout();
  }
}
